import { RedemptionStatus } from './types'

/**
 * Extracts the code value from a scanned QR code string.
 * QR codes encode URLs in the format: https://q.a4.vc/{code}[/extra/segments]
 * This function extracts only the first path segment as the code value.
 * If the input is not a valid URL (e.g. manual entry), it returns the input as-is.
 */
export const extractCodeFromScan = (scannedValue: string): string => {
  const trimmed = scannedValue.trim()

  try {
    const url = new URL(trimmed)
    const pathSegments = url.pathname.split('/').filter(Boolean)
    return pathSegments[0] ?? trimmed
  } catch {
    return trimmed
  }
}

export const codeStatusMap: { [key: string]: 'success' | 'error' } = {
  INVALID_CODE: 'error',
  ALREADY_CLAIMED: 'error',
  SUPER_CODE_SUCCESS: 'success',
  FIRST_CODE_SUCCESS: 'success',
  REGULAR_SUCCESS: 'success',
  REGULAR_10_CODES_LEFT_SUCCESS: 'success',
  REGULAR_ERROR_EXCEED: 'error',
  CLUB36_SUCCESS: 'success',
  CLUB36_10_CODES_LEFT_SUCCESS: 'success',
  CLUB36_ERROR_EXCEED: 'error',
  SERVER_ERROR: 'error'
}

const statusToEnum: { [key: string]: RedemptionStatus } = {
  INVALID_CODE: RedemptionStatus.InvalidCode,
  ALREADY_CLAIMED: RedemptionStatus.InvalidCode,
  SUPER_CODE_SUCCESS: RedemptionStatus.SuperCodeSuccess,
  FIRST_CODE_SUCCESS: RedemptionStatus.FirstCodeSuccess,
  REGULAR_SUCCESS: RedemptionStatus.RegularSuccess,
  REGULAR_10_CODES_LEFT_SUCCESS: RedemptionStatus.RegularTenCodesLeftSuccess,
  REGULAR_ERROR_EXCEED: RedemptionStatus.RegularErrorExceed,
  CLUB36_SUCCESS: RedemptionStatus.Club36Success,
  CLUB36_10_CODES_LEFT_SUCCESS: RedemptionStatus.Club36TenCodesLeftSuccess,
  CLUB36_ERROR_EXCEED: RedemptionStatus.Club36ErrorExceed,
  SERVER_ERROR: RedemptionStatus.ServerError
}

export const mapStatusToEnum = (status?: string): RedemptionStatus => {
  if (!status) {
    return RedemptionStatus.ServerError
  }

  if (statusToEnum[status]) {
    return statusToEnum[status]
  }

  return RedemptionStatus.ServerError
}
